import { Modal, Button, Spinner } from 'react-bootstrap';
import { usePAChecklist } from '../pa_checklist_context';
import styles from '../pa_checklist.module.scss';
import Tabela from '../../../Misc/Tabela/Tabela';
import { useEffect, useState } from 'react';
import { capitalizeFirstChar } from '../../../../utils/misc_utils';
import MaterialIcon from 'material-icons-react';
import { api } from '../../../../services/api';
import { toast } from 'react-toastify';
import PAChecklistModalLocalizacao from './pa_checklist_modal_localizacao';
import { useMisc } from "../../../../contexts/MiscContext";
import MaterialIconsReact from 'material-icons-react';

const PAChecklistInformacoes = () => {
  const { setShowLoading } = useMisc();
  const { showModalInformacoes, fecharModalInformacoes, gradeChecklist, revisaoResultado, revisaoDirecionamentos, medidasAtelier, informacaoAtiva, informacoesCarregadas, fetchDefeitos, fetchChamados, carregandoDefeitosPit, carregandoChamados, interfaceAtiva, medidasAnalise, imagemDesenhoTecnico } = usePAChecklist();

  const [direcionamentosRevisaoFormatado, setDirecionamentosRevisaoFormatado] = useState([]);
  const [corStatusRevisao, setCorStatusRevisao] = useState('#FFFFFF');
  const [qtdeDirecionadaRevisao, setQtdeDirecionadaRevisao] = useState(0);
  const [defeitosPitArr, setDefeitosPitArr] = useState([]);
  const [informacoes, setInformacoes] = useState({});
  const [showModalLocalizacao, setShowModalLocalizacao] = useState(false);
  const [localizacoes, setLocalizacoes] = useState([]);

  const grade_columns = [
    { name: 'Tamanho', selector: row => row.tamanho },
    { name: 'Quantidade', selector: row => row.quantidade_total }
  ];

  const medida_columns = medidasAtelier[0] ? Object.keys(medidasAtelier[0]).map((key, index) => ({
    name: capitalizeFirstChar(key),
    selector: row => row[key] || '-',
    width: index === 1 ? '200px' : undefined
  })) : [
    { name: 'Medida', selector: row => '' },
    { name: 'Tamanho', selector: row => '' },
    { name: 'Tolerância', selector: row => '' }
  ];

  const medidas_analise = [
    { name: 'Parte', selector: row => row.descricao_parte || '-', width: '200px' },
    { name: 'Grade', selector: row => row.descricao_grade || '-' },
    { name: 'Medição FT', selector: row => row.medicao_ft || '-' },
    { name: 'Piloto', selector: row => row.piloto || '-' },
    { name: 'Tolerância', selector: row => row.tolerancia || '-' },
    { name: 'A. Obrigatoria', selector: row => row.amostra_obrigatoria || '-' },
    { name: 'A. Opcional', selector: row => row.amostra_opcional || '-' },
    { name: 'Aceitável?', selector: row => row.medida_aceitavel || '-' }
  ];

  const direcionamento_revisao_columns = [
    { name: 'Destino', selector: row => row.descricao_destino },
    { name: 'Qtde. Peças', selector: row => row.qtde_pecas },
    { name: 'Tamanho', selector: row => row.descricao_grade },
    { name: 'Defeito', selector: row => row.defeito }
  ];

  useEffect(() => {
    const agruparDirecionamento = () => {
      const groupedData = [];

      revisaoDirecionamentos.forEach(item => {
        let grupoExistente = groupedData.find(grupo => grupo.id_direcionamento_pa === item.id_direcionamento_pa);

        if (grupoExistente) return grupoExistente.defeito += ` | ${item.defeito}`;

        groupedData.push({
          id_direcionamento_pa: item.id_direcionamento_pa,
          descricao_destino: item.descricao_destino,
          qtde_pecas: item.qtde_pecas,
          descricao_grade: item.descricao_grade,
          defeito: item.defeito,
        });
      });

      const qtdeDirRev = groupedData.reduce((acc, item) => {
        return acc + item.qtde_pecas;
      }, 0);
      setQtdeDirecionadaRevisao(qtdeDirRev);
      setDirecionamentosRevisaoFormatado([...groupedData]);
    }

    const getCor = () => {
      if (revisaoResultado.id_status_revisao === 4) return '#B4E380';
      if ([5, 7].includes(revisaoResultado.id_status_revisao)) return '#F6FB7A';
      if ([8, 9].includes(revisaoResultado.id_status_revisao)) return '#FF7777';
    }

    setCorStatusRevisao(getCor());
  }, []);

  useEffect(() => {
    const defeitosPitList = [];
    const defeitosPitAtivos = informacoesCarregadas[informacaoAtiva].defeitosPit;

    if (!defeitosPitAtivos) return;
    for (const item of defeitosPitAtivos) {
      const listItem = Object.keys(item).reduce((arr, key) => {
        if (item[key] === true && key !== 'outros') arr.push(key);
        return arr;
      }, []);

      if (item.outros === true) listItem.push(item.s_outros);
      defeitosPitList.push(listItem);
    }

    setDefeitosPitArr([...defeitosPitList]);
    setInformacoes({ ...informacoesCarregadas[informacaoAtiva] });
  }, [informacoesCarregadas]);

  const abrirModalLocalizacao = async () => {
    setShowLoading(true);
    try {
      if (localizacoes.length > 0) return setShowModalLocalizacao(true);

      const params = { produto: informacoes.produto, cor_produto: informacoes.cor_produto }
      const res = await api.get('pa-checklist/checklist-localizacao', { params });
      if (res.data.length === 0) return toast.warn('Não há localizações disponíveis para esse produto e cor com o código iniciado por 440.');
      setLocalizacoes([...res.data]);
      setShowModalLocalizacao(true);
    } catch (e) {
      toast.error('Não foi possível carregar as informações de localização da referência. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  return (
    <Modal
      show={showModalInformacoes}
      size={'lg'}
      onHide={fecharModalInformacoes}
      centered={true}
      backdropClassName={styles.backdrop_z_override}
    >
      <Modal.Header closeButton style={{ fontWeight: '500' }}>
        Referência {informacoes.nf_segunda_qualidade ? '(Segunda Qualidade)' : ''} | NF: {informacoes.nf_entrada} | Produto: {informacoes.produto} | Cor: {informacoes.cor_produto}
      </Modal.Header>
      <Modal.Body className={styles.modal_body}>
        <section className={styles.dados_conferencia}>
          <span className={styles.accordion_item}>Nota Fiscal:<div className={styles.font_blue}>{informacoes.nf_entrada}</div></span>
          <span className={styles.accordion_item}>Série:<div className={styles.font_blue}>{informacoes.serie_nf}</div></span>
          <span className={styles.accordion_item}>Origem:<div className={styles.font_blue}>{informacoes.origem}</div></span>
          <span className={styles.accordion_item}>Produto:<div className={styles.font_blue}>{informacoes.produto}</div></span>
          <span className={styles.accordion_item}>Descrição Produto:<div className={styles.font_blue}>{informacoes.descricao_produto}</div></span>
          <span className={styles.accordion_item}>Cor Produto:<div className={styles.font_blue}>{informacoes.cor_produto}</div></span>
          <span className={styles.accordion_item}>Descrição Cor:<div className={styles.font_blue}>{informacoes.descricao_cor}</div></span>
          <span className={styles.accordion_item}>Filial Revisão:<div className={styles.font_blue}>{informacoes.filial_revisao}</div></span>
          <span className={styles.accordion_item}>Qtde. Entrada:<div className={styles.font_blue}>{informacoes.qtde_entrada}</div></span>
          <span className={styles.accordion_item}>Data Entrada Revisão:<div className={styles.font_blue}>{informacoes.data_entrada_revisao_br}</div></span>
          <span className={styles.accordion_item}>Ordem Produção:<div className={styles.font_blue}>{informacoes.ordem_producao}</div></span>
          <span className={styles.accordion_item}>Segunda Qualidade? <div className={styles.font_blue}>{informacoes.nf_segunda_qualidade ? 'Sim' : 'Não'}</div></span>
          <span className={styles.accordion_item}>Marca<div className={styles.font_blue}>{informacoes.marca}</div></span>
          <span className={styles.accordion_item}>
            <div className={styles.font_blue} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-end', height: '100%' }}>
              <Button
                style={{ fontWeight: '500' }}
                variant={'primary'}
                onClick={async () => await abrirModalLocalizacao()}
              >
                Localização
              </Button>
            </div>
          </span>
          <span className={styles.accordion_item}>
            <div className={styles.font_blue} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-end', height: '100%' }}>
              <Button
                style={{ fontWeight: '500' }}
                variant={'primary'}
                onClick={async () => {
                  try {
                    const res = await api.get('pa-checklist/ficha-tecnica', { params: { produto: informacoes.produto } });
                    if (!res.data) return toast.warn('Ficha técnica indisponível para esse produto.');
                    window.open(res.data, '_blank');
                  } catch (e) {
                    toast.error('Erro ao buscar a ficha técnica do produto. Tente novamente ou entre em contato com o suporte.');
                  }
                }}
              >
                Ficha Técnica
              </Button>
            </div>
          </span>

          <div className={styles.separator} />

          <div className={styles.chamados_wrapper}>
            <div className={styles.chamados_list}>
              <span className={styles.accordion_item}>Chamados</span>&nbsp;
              <i
                onClick={() => fetchChamados(informacoes)}
                style={{ cursor: 'pointer' }}
              >
                <MaterialIcon
                  icon="autorenew"
                  size={15}
                  color='#000000'
                />
              </i>
              <br />
              {carregandoChamados ? <Spinner size={'sm'} /> :
                informacoes.chamados && informacoes.chamados.map((item, index) => {
                  return (
                    <div key={index}>
                      Chamado {item.id_divergencia} |&nbsp;
                      <a
                        href={`https://plm-colaborativo.somalabs.com.br/produtos/${item.id_producao_prog_prod}/${item.id_producao_ppp_op}/divergencias?open=${item.id_divergencia}`}
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                      >
                        abrir chamado
                      </a>
                    </div>
                  );
                })}
              {informacoes.chamados && informacoes.chamados.length === 0 ? 'Nenhum chamado encontrado' : null}
            </div>
            <div className={styles.vertical_separator} />
            <div className={styles.chamados_list}>
              <span className={styles.accordion_item}>Defeitos declarados</span>&nbsp;
              <i
                onClick={() => fetchDefeitos(informacoes)}
                style={{ cursor: 'pointer' }}
              >
                <MaterialIcon
                  icon="autorenew"
                  size={15}
                  color='#000000'
                />
              </i>
              <br />
              {carregandoDefeitosPit ? <Spinner size={'sm'} /> :
                defeitosPitArr.map((item, index) => {
                  return (
                    <div key={index}>
                      Código Espelho {informacoes.defeitosPit[index].codigo_espelho} |&nbsp;
                      {item.length > 0 ? item.join(', ') : 'Nenhum defeito declarado'}
                    </div>
                  );
                })}
              {defeitosPitArr.length === 0 ? 'Nenhum defeito declarado' : null}
            </div>
          </div>
        </section>

        <div className={styles.separator} />

        <div className={styles.resumo_row}>
          <section className={styles.dados_analise_wrapper}>
            <div className={styles.status_wrapper}>
              <label className={styles.sub_form_label}>Status Revisão</label>
              <div
                className={styles.status_box}
                style={{ backgroundColor: corStatusRevisao }}
              >
                {revisaoResultado.status_revisao}
              </div>
            </div>

            <div className={styles.dados_analise_item_duplo}>
              <div>
                <label className={styles.sub_form_label}>Quantidade Amostra Revisão</label>
                <span className={styles.font_blue_big}>{revisaoResultado.qtde_pecas_amostra_revisao}</span>
              </div>
              <div>
                <label className={styles.sub_form_label}>Quantidade Direcionada Revisão</label>
                <span className={styles.font_blue_big}>{qtdeDirecionadaRevisao}</span>
              </div>
            </div>

            <div
              style={{
                display: informacoes.nf_segunda_qualidade || informacoes.produto_de_couro ? 'block' : 'none'
              }}
              className={styles.dados_analise_item}
            >
              <label
                style={{ display: informacoes.nf_segunda_qualidade ? 'block' : 'none' }}
                className={styles.sub_form_label}
              >
                Esta é uma nota fiscal de segunda qualidade - Portanto todas as peças foram revisadas
              </label>
              <label
                style={{ display: informacoes.produto_de_couro ? 'block' : 'none' }}
                className={styles.sub_form_label}
              >
                Esta é uma nota fiscal de couro - Portanto todas as peças foram revisadas
              </label>
            </div>

            {interfaceAtiva !== 102 &&
              <div>
                <label className={styles.form_label}>Grade (somente conferência)</label>
                <Tabela
                  columns={grade_columns}
                  data={gradeChecklist}
                  pagination={false}
                />
              </div>
            }
          </section>
        </div>

        <div className={styles.separator} />

        <section className={styles.grade_conferencia}>
          <label className={styles.form_label}>Direcionamentos Revisão (somente conferência)</label>
          <Tabela
            columns={direcionamento_revisao_columns}
            data={revisaoDirecionamentos}
            pagination={false}
          />
        </section>

        <div className={styles.separator} />

        <section className={styles.grade_conferencia}>
          <label className={styles.form_label}>Medidas Ficha Técnica - Atelier (somente conferência)</label>
          <Tabela
            columns={medida_columns}
            data={medidasAtelier}
            pagination={false}
          />
        </section>

        <section className={styles.grade_conferencia}>
          <label className={styles.form_label}>Medidas Inseridas - Etapa de Análise</label>
          <Tabela
            columns={medidas_analise}
            data={medidasAnalise}
            pagination={false}
          />
        </section>

        {
          imagemDesenhoTecnico &&
          <div style={{ display: 'flex' }}>
            <div style={{ width: '38px' }} />
            <img src={imagemDesenhoTecnico} width={'50%'} style={{ margin: 'auto' }} />
          </div>
        }
        {
          !imagemDesenhoTecnico &&
          <div className={styles.warn_text}>Não há desenho técnico disponível para esse produto</div>
        }
      </Modal.Body>
      <Modal.Footer className={styles.modal_footer}>
        <Button
          variant={'secondary'}
          onClick={fecharModalInformacoes}
          className={styles.footer_btn_processamento}
        >
          Fechar
        </Button>
      </Modal.Footer>

      {
        showModalLocalizacao &&
        <PAChecklistModalLocalizacao
          produto={informacoes.produto}
          cor_produto={informacoes.cor_produto}
          localizacoes={localizacoes}
          showModalLocalizacao={showModalLocalizacao}
          setShowModalLocalizacao={setShowModalLocalizacao}
        />
      }
    </Modal>
  )
}

export default PAChecklistInformacoes;
